import {ErrorFlow} from 'olympe';
import {LAMBDA_NAMES} from '../utils/constants';

/**
 * Static class that control materials.
 */
export class MaterialController {
    /**
     * Get the first ZSIM Material linked to an UNBW material. A Material is linked to another if they have the same material group
     * @param {BrickContext} $
     * @param {Material} material
     * @return {Promise<{matnr: string, maktx: string, mstae: string}[]>}
     */
    static getZSIMMaterialFromAnotherByL3($, material) {
        const getZSIMMaterialFromAnotherByL3Lambda = $.get(LAMBDA_NAMES.GET_ZSIM_MATERIAL_FROM_ANOTHER_BY_L3_CAT);

        return new Promise((resolve, reject) => {
            const [
                controlFlowIn,
                materialIn,
            ] = getZSIMMaterialFromAnotherByL3Lambda.getInputs();

            const [
                SuccessOut,
                resultOut,
                ErrorOut,
            ] = getZSIMMaterialFromAnotherByL3Lambda.getOutputs();

            const getZSIMMaterialRunner = $.runner(getZSIMMaterialFromAnotherByL3Lambda)
                .set(materialIn, material.name.split(' - ')[0])
                .trigger(controlFlowIn);

            Promise.any([
                getZSIMMaterialRunner.waitFor(SuccessOut),
                getZSIMMaterialRunner.waitFor(ErrorOut),
            ]).then((outputFlow) => {
                if (outputFlow instanceof ErrorFlow) {
                    reject(outputFlow);
                } else {
                    resolve(JSON.parse(getZSIMMaterialRunner.get(resultOut)));
                }
            }).catch(reject)
                .finally(() => getZSIMMaterialRunner.destroy());
        });
    }
}
